export { ParentHeader } from "./ParentHeader"
export type { ParentHeaderProps } from "./ParentHeader"
